import { DetailSection } from 'components/Find/detail';

interface Props {
  /** Court cost per player in major units; `undefined` renders "Free". */
  courtCostPerPlayer?: number;
  paymentMethod: string;
}

export default function MatchPrice({ courtCostPerPlayer, paymentMethod }: Props) {
  return (
    <DetailSection title="Price" sizeDesktop="lg">
      <div className="flex flex-col gap-ds-md lg:gap-ds-sm">
        <div className="flex items-center justify-between gap-ds-sm">
          <span className="typography-product-caption lg:typography-product-body text-color-text-lightmode-secondary dark:text-color-text-darkmode-secondary">
            Court cost per player
          </span>
          <span className="typography-product-heading-mobile lg:typography-product-heading-desktop text-color-text-lightmode-primary dark:text-color-text-darkmode-primary">
            {courtCostPerPlayer !== undefined ? `$${courtCostPerPlayer}` : 'Free'}
          </span>
        </div>

        <div className="flex items-center justify-between gap-ds-sm">
          <span className="typography-product-caption lg:typography-product-body text-color-text-lightmode-secondary dark:text-color-text-darkmode-secondary">
            Payment method
          </span>
          <span className="typography-product-card-title-mobile lg:typography-product-card-title-desktop text-color-text-lightmode-primary dark:text-color-text-darkmode-primary">
            {paymentMethod}
          </span>
        </div>
      </div>
    </DetailSection>
  );
}
